import { Path } from '@/main/router/routerPath';

import { NAME, VOZIDLO_DATA_TYPE, VOZIDLO_MERGE, CRUMB_LABEL_KEY, VOZIDLO_CDB } from './constants';
import { OdlozenyServis } from './activity/odlozenyServis';
import { DoServisuPredal } from './activity/doServisuPredal';
import { VozidloCDB } from './vozidloCDB';
import List from './List.vue';
import Edit from './Edit.vue';
import DataList from './DataList.vue';
import SelectList from './SelectList.vue';
import Merge from './Merge.vue';

export const router = new Path().addChildren([
	new Path(NAME, { List, Edit, SelectList }, CRUMB_LABEL_KEY),
	new Path(VOZIDLO_MERGE, { Edit: Merge }, CRUMB_LABEL_KEY),
	new Path(VOZIDLO_DATA_TYPE.HISTORIEOPRAV, { List: DataList }, 'grdVozidloHistorieOprav'),
	new Path(VOZIDLO_DATA_TYPE.OBRATYOPRAV, { List: DataList }, 'grdVozidloObratyOprav'),
	new Path(VOZIDLO_DATA_TYPE.SDA, { List: DataList }, 'fltSda'),
	new Path(VOZIDLO_DATA_TYPE.SERVICEKEY, { List: DataList }, 'grdIKey'),
	VozidloCDB.router,
	OdlozenyServis.router,
	DoServisuPredal.router,
]);
